import React from "react";
import { ENV, s3_bucket_prod_url, s3_bucket_uat_url, SUB_DIRECTORY } from "../../common/constant";

const Contact = (props) => {


    const renderContact = () => {
        var titleArr = []

        props.contactPersonArr !== null && props.contactPersonArr.length > 0 ?
            props.contactPersonArr.map((item, index) => (
                titleArr.push(
                    <div class="card mt-3">
                        <div class="card-body ">
                            <div class="d-flex user-card">
                                {

                                    item.actual_file_relative_url != null ?
                                        <div class="col-3 _img text-center">
                                            <img src={`${ENV === 'development' ? s3_bucket_uat_url : s3_bucket_prod_url}${item.actual_file_relative_url}`} class="img-fluid rounded-pill" alt="" />
                                        </div>
                                        :
                                        <div class="profile-container">
                                            <div class="initial-text">
                                                {item.first_name[0]}{item.last_name[0]}
                                            </div>
                                        </div>
                                }
                                <div className="col-9 my-auto _info px-3">
                                    <h6 class="mb-1">RM : <b>{item.first_name}</b> {item.last_name}</h6>
                                    <p className="mb-0">
                                        <a href="tel:918169935573" class="text-primary"><i class="fa fa-phone"></i>&nbsp;&nbsp;+91-{item.mobile_no} </a>
                                    </p>
                                    <a class="small" href={`mailto:${item.email}`}><i class="fa fa-envelope"></i>&nbsp;&nbsp;{item.email}</a>
                                </div>

                            </div>
                        </div >
                    </div >


                )
            ))

            :
            <div class="card mt-3">
                <div class="card-body ">
                    <div class="d-flex user-card">
                        <p>No Assigned RM</p>
                    </div>
                </div>
            </div>


        return titleArr
    }


    return (
        <div class="mb-3">
            <span class="fw-bold">Contact Person</span>
            {renderContact()}
        </div>
    )
}

export default Contact;